export const IO_DEVICES = {
  MICROPHONE: 'Microphone',
  SPEAKER: 'Speaker',
  CAMERA: 'Camera',
  EFFECT: 'Effect',
}

export enum RECORDING_STATUS {
  disabled = 'disabled',
  not_started = 'not_started',
  pending = 'pending',
  saved = 'saved',
  saved_deleted = 'saved_deleted',
  disabled_deleted = 'disabled_deleted',
  failed = 'failed',
  expired = 'expired',
  awaiting_recording_consent = 'awaiting_recording_consent',
}

export const RECORDING_AVAILABLE_STATUSES: ReadonlySet<RECORDING_STATUS> = new Set([
  RECORDING_STATUS.saved,
  RECORDING_STATUS.saved_deleted,
])
